import { Box, Head } from '@medely/web-components';
import React from 'react';
import TopBarDesktop from './TopBarDesktop';
import TopBarMobile from './TopBarMobile';
import useDevice from 'hooks/useDevice';
import { useReferralToken } from '@src/components/referralTag/graphql';
import { useAssignmentContext } from '@mp/contexts';

const TopBarDefault = (): React.ReactElement => {
  const { referralToken, isLoading } = useReferralToken();
  const hasToken = !isLoading && referralToken;
  const isDesktop = useDevice() === 'desktop';
  const { assignment } = useAssignmentContext();

  return (
    <Box width="100%" data-testid="header">
      <Head>{hasToken && <script>{`window.impactToken = "${referralToken}"`}</script>}</Head>
      {isDesktop ? <TopBarDesktop assignment={assignment || undefined} /> : <TopBarMobile />}
    </Box>
  );
};

export default TopBarDefault;
